import { render, staticRenderFns } from "./connected-authorization-dialog.vue?vue&type=template&id=47601fdd&"
import script from "./connected-authorization-dialog.vue?vue&type=script&lang=js&"
export * from "./connected-authorization-dialog.vue?vue&type=script&lang=js&"
import style0 from "./connected-authorization-dialog.vue?vue&type=style&index=0&id=47601fdd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports